/** Transforms path to title
 * /user-profile -> User Profile
 * This helper is meant to be used in the Google Analytics 4 tag manager
 */
export const pathToTitle = (path: string): string => {
  return path
    .substring(1)
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};
